export const PROVIDERS_QUERY = `
query SearchProviders($site: String!, $gameFilter: GameAvailabilityFilter!) {
  casinoGameInventory {
    gameProvidersWithGames(site: $site, gameFilter: $gameFilter) {
      id
      name
      handle
      totalCount
    }
  }
}
`;
